import { Cidade, Pessoa, PessoaEndereco, PessoaFisica } from "@tivic-team/manager-ts/dist/grl";
import { PessoaFichaMedica } from "@tivic-team/manager-ts/dist/grl/entities/pessoa-ficha-medica.entity";

export class PessoaFichaMedicaDTO extends Pessoa{
    cidade: Cidade = void(0);
    pessoaFisica: PessoaFisica = void(0);
    pessoaEndereco: PessoaEndereco = void(0);
    pessoaFichaMedica: PessoaFichaMedica = void(0);

    constructor(
        cidade?:Cidade,
        pessoaFisica?:PessoaFisica,
        pessoaEndereco?:PessoaEndereco,
        pessoaFichaMedica?:PessoaFichaMedica){
        super();
        this.cidade = cidade;
        this.pessoaFisica = pessoaFisica;
        this.pessoaEndereco = pessoaEndereco;
        this.pessoaFichaMedica = pessoaFichaMedica;
    }
}

export class PessoaFichaMedicaListDTO {
    items: Array<PessoaFichaMedicaDTO>;
    total: number;
    constructor() {}
}